import {IconControl} from 'spark-core-dx/components';
import moment from 'moment';

export const DateInformation = ({
	startDate,
	endDate,
	handleCalendarButtonClick
}) => {
	return (
		<div className="dashboard-filter-date-container">
			<div className="dashboard-filter-date-information">
				<div className="dashboard-date-start">
					Start
					<div className="dashboard-date">
						{startDate ? moment(startDate).format('MM/DD/YYYY') : 'No Date'}
					</div>
				</div>

				<div className="dashboard-filter-calendar-button">
					<IconControl
						iconKey={"calendartoday"}
						onClick={handleCalendarButtonClick}
						height={'1.875rem'}
						width={'1.875rem'}
						color={"white"}
					/>
				</div>

				<div className="dashboard-date-end">
					End
					<div className="dashboard-date">
						{endDate ? moment(endDate).format('MM/DD/YYYY') : 'No Date'}
					</div>
				</div>
			</div>
		</div>
	);
};